export enum HttpStatusCode {
    Unknown = 0,
    OK = 200,
    Created = 201,
    NoContent = 204,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    RequestTimeout = 408,
    RequestEntityTooLarge = 413,
    UnsupportedMediaType = 415,
    RangeNotSatisfiable = 416,
    Locked = 423,
    Throttled = 429,
    InternalServerError = 500,
    NotImplemented = 501,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    InsufficientStorage = 507,
    UnexpectedResponse = 700,
    TokenRefreshFailed = 701,
    TokenUnavailable = 702,
    RetryFailed = 703,
    AlternateResponse = 704,
    Cancelled = 705,
    Offline = 706,
    Timeout = 707,
    DecryptionError = 708,
    CacheMiss = 709
}
